/* eslint-disable */
import { token } from "../helpers/get-token";
export function authHeader() {
  // return authorization header with jwt token
  const token = JSON.stringify(token);
  if (token) {
    return { Authorization: `Bearer ${token}` };
  }
  return {};
}
/* eslint-enable */
